// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"119":"63d558f4","487":"cce58780","641":"53128e0e","756":"3891702c"}[chunkId] + ".chunk.css";
};